import ViewViewModel from '@/ViewModels/ViewViewModel';
import TextBoxViewModelT from '@/ViewModels/Controls/TextBoxViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ButtonViewModelT from '@/ViewModels/Controls/ButtonViewModel';
import ResourceManager from '@/Management/ResourceManager';
import ButtonViewModelBuilder from '@/Builder/ButtonViewModelBuilder';
import Utilities from '@/Utility/Utilities';
import {ITokenValidationViewModelConstructorParameter} from '#/DefaultViewExtensionInterfaces';

export default class TokenValidationViewModel extends ViewViewModel {

    private TextBoxViewModel = ComponentManager.getViewModel<typeof TextBoxViewModelT>('TextBoxViewModel');
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');

    private onSubmit: (token: string) => JQueryPromise<boolean>;
    private onCancel: () => void;

    public titleLabel: LabelViewModelT;
    public usernameLabel: LabelViewModelT;
    public infoTextLabel: LabelViewModelT;
    
    public tokenTextBox: TextBoxViewModelT;
    public cancelButton: ButtonViewModelT;
    public submitButton: ButtonViewModelT;

    constructor(params: ITokenValidationViewModelConstructorParameter) {
        super(params);

        this.onSubmit = this.handlerOrDefault(params.onSubmit, () => Utilities.resolveImmediately(true));
        this.onCancel = this.handlerOrDefault(params.onCancel);

        this.titleLabel = this.createTitleLabel();
        this.usernameLabel = this.createUsernameLabel(params.username);
        this.infoTextLabel = this.createInfoTextLabel(params.infoTextErgName);
        this.tokenTextBox = this.createTokenTextBox();
        this.cancelButton = this.createCancelButton();
        this.submitButton = this.createSubmitButton(params.buttonErgname);
    }

    private createTitleLabel(): LabelViewModelT {
        return new this.LabelViewModel({
            ergName: 'TWO_FA.TITLE'
        });
    }

    private createUsernameLabel(username?: string): LabelViewModelT {
        const prefix = ResourceManager.getInstance().get('USER_NAME');
        return new this.LabelViewModel({
            caption: `${prefix}: ${username}`
        });
    }

    private createInfoTextLabel(infoTextErgName: string): LabelViewModelT {
        return new this.LabelViewModel({
            ergName: 'MENU_CHANGE_PASSWORD_TWO_FA_INFO'
        });
    }

    private createTokenTextBox(): TextBoxViewModelT {
        return new this.TextBoxViewModel({
            name: 'tokenTextBox',
            parentLocator: this.locator,
            locator: 'code',
            onSubmit: () => {
                this.submit();
            },
            placeholder: ResourceManager.getInstance().get('TWO_FA.CODE'),
            isFocusable: true
        });
    }

    private createCancelButton(): ButtonViewModelT {
        return new ButtonViewModelBuilder()
            .withParentLocator(this.locator)
            .withLocator('cancel')
            .withLabel()
            .withErgName('STEP_BACK')
            .done()
            .withOnClick(() => {
                this.onCancel();
            })
            .build();
    }

    private createSubmitButton(buttonErgname: string): ButtonViewModelT {
        return new ButtonViewModelBuilder()
            .withParentLocator(this.locator)
            .withLocator('submit')
            .withLabel()
            .withErgName('DO_LOGIN')
            .done()
            .withIsEnabled(this.defineComputed(() => {
                const token = this.tokenTextBox.value();
                return !Utilities.isNullOrUndefinedOrBlank(token);
            }))
            .withOnClick(() => {
                this.submit();
            })
            .build();
    }

    private submit() {
        const token = this.tokenTextBox.value();
        this.onSubmit(token).then(success => {
            if (this.isDisposed) {
                return;
            }
        });
    }
}

ComponentManager.setViewModel('TokenValidation', TokenValidationViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');